module.exports = __webpack_public_path__ + "img/hero-sm.6c4e5b1d.jpg";